export const integrationsBaseRoute = '/settings/integrations';
export const capitalizeFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
export const partnerIntegrationNotificationTimeout = 5000;
